import { render } from "./EventCalendar.vue?vue&type=template&id=b051b7de"
import script from "./EventCalendar.vue?vue&type=script&lang=js"
export * from "./EventCalendar.vue?vue&type=script&lang=js"

import "./EventCalendar.vue?vue&type=style&index=0&id=b051b7de&lang=scss"
script.render = render

export default script